import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";

interface SidebarContextValue {
	isOpen: boolean;
	toggle: () => void;
	close: () => void;
}

const SidebarContext = createContext<SidebarContextValue | null>(null);

export function SidebarProvider({ children }: { children: React.ReactNode }) {
	const [isOpen, setIsOpen] = useState(false);
	const location = useLocation();

	const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
	const close = useCallback(() => setIsOpen(false), []);

	// biome-ignore lint/correctness/useExhaustiveDependencies: intentionally re-run on route change
	useEffect(() => {
		setIsOpen(false);
	}, [location.pathname]);

	return (
		<SidebarContext.Provider value={{ isOpen, toggle, close }}>{children}</SidebarContext.Provider>
	);
}

export function useSidebar() {
	const context = useContext(SidebarContext);
	if (!context) {
		throw new Error("useSidebar must be used within a SidebarProvider");
	}
	return context;
}
